module.exports = __webpack_public_path__ + "img/chnage_b.49b4d7ec.svg";